/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */

import { library } from '@fortawesome/fontawesome-svg-core';

// Brands
import { faAppStore as fabAppStore } from '@fortawesome/free-brands-svg-icons/faAppStore';
import { faGooglePlay as fabGooglePlay } from '@fortawesome/free-brands-svg-icons/faGooglePlay';
import { faFacebook as fabFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import { faInstagram as fabInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedin as fabLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';
import { faPinterest as fabPinterest } from '@fortawesome/free-brands-svg-icons/faPinterest';
import { faTumblr as fabTumblr } from '@fortawesome/free-brands-svg-icons/faTumblr';
import { faTwitter as fabTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faYoutube as fabYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faBloggerB as fabBloggerB } from '@fortawesome/free-brands-svg-icons/faBloggerB';
import { faXTwitter as fabXTwitter } from '@fortawesome/free-brands-svg-icons/faXTwitter';

// Regular
import { faAt as farAt } from '@fortawesome/pro-regular-svg-icons/faAt';
import { faAward as farAward } from '@fortawesome/pro-regular-svg-icons/faAward';
import { faCalendar as farCalendar } from '@fortawesome/pro-regular-svg-icons/faCalendar';
import { faCheckCircle as farCheckCircle } from '@fortawesome/pro-regular-svg-icons/faCheckCircle';
import { faCircleDollar as farCircleDollar } from '@fortawesome/pro-regular-svg-icons/faCircleDollar';
import { faDownload as farDownload } from '@fortawesome/pro-regular-svg-icons/faDownload';
import { faEnvelope as farEnvelope } from '@fortawesome/pro-regular-svg-icons/faEnvelope';
import { faFileCertificate as farFileCertificate } from '@fortawesome/pro-regular-svg-icons/faFileCertificate';
import { faHandWave as farHandWave } from '@fortawesome/pro-regular-svg-icons/faHandWave';
import { faHandshake as farHandshake } from '@fortawesome/pro-regular-svg-icons/faHandshake';
import { faHeart as farHeart } from '@fortawesome/pro-regular-svg-icons/faHeart';
import { faMemoCircleCheck as farMemoCircleCheck } from '@fortawesome/pro-regular-svg-icons/faMemoCircleCheck';
import { faPrint as farPrint } from '@fortawesome/pro-regular-svg-icons/faPrint';
import { faSearch as farSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';
import { faSearchPlus as farSearchPlus } from '@fortawesome/pro-regular-svg-icons/faSearchPlus';
import { faStroopwafel as farStroopwafel } from '@fortawesome/pro-regular-svg-icons/faStroopwafel';
import { faTriangleExclamation as farTriangleExclamation } from '@fortawesome/pro-regular-svg-icons/faTriangleExclamation';
import { faUser as farUser } from '@fortawesome/pro-regular-svg-icons/faUser';

// Solid
import { faAngleLeft as fasAngleLeft } from '@fortawesome/pro-solid-svg-icons/faAngleLeft';
import { faAngleRight as fasAngleRight } from '@fortawesome/pro-solid-svg-icons/faAngleRight';
import { faAt as fasAt } from '@fortawesome/pro-solid-svg-icons/faAt';
import { faAward as fasAward } from '@fortawesome/pro-solid-svg-icons/faAward';
import { faBars as fasBars } from '@fortawesome/pro-solid-svg-icons/faBars';
import { faBookReader as fasBookReader } from '@fortawesome/pro-solid-svg-icons/faBookReader';
import { faBug as fasBug } from '@fortawesome/pro-solid-svg-icons/faBug';
import { faBuilding as fasBuilding } from '@fortawesome/pro-solid-svg-icons/faBuilding';
import { faBullhorn as fasBullhorn } from '@fortawesome/pro-solid-svg-icons/faBullhorn';
import { faMegaphone as fasMegaphone } from '@fortawesome/pro-solid-svg-icons/faMegaphone';
import { faCalendar as fasCalendar } from '@fortawesome/pro-solid-svg-icons/faCalendar';
import { faCaretDown as fasCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faCaretLeft as fasCaretLeft } from '@fortawesome/pro-solid-svg-icons/faCaretLeft';
import { faChartLine as fasChartLine } from '@fortawesome/pro-solid-svg-icons/faChartLine';
import { faCheck as fasCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faCheckCircle as fasCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faChevronLeft as fasChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faCircle as fasCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { faCircleNotch as fasCircleNotch } from '@fortawesome/pro-solid-svg-icons/faCircleNotch';
import { faCity as fasCity } from '@fortawesome/pro-solid-svg-icons/faCity';
import { faClipboardCheck as fasClipboardCheck } from '@fortawesome/pro-solid-svg-icons/faClipboardCheck';
import { faClock as fasClock } from '@fortawesome/pro-solid-svg-icons/faClock';
import { faCommentDots as fasCommentDots } from '@fortawesome/pro-solid-svg-icons/faCommentDots';
import { faDollarSign as fasDollarSign } from '@fortawesome/pro-solid-svg-icons/faDollarSign';
import { faDownload as fasDownload } from '@fortawesome/pro-solid-svg-icons/faDownload';
import { faEnvelope as fasEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faExclamationTriangle as fasExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import { faFax as fasFax } from '@fortawesome/pro-solid-svg-icons/faFax';
import { faFileCertificate as fasFileCertificate } from '@fortawesome/pro-solid-svg-icons/faFileCertificate';
import { faGlobe as fasGlobe } from '@fortawesome/pro-solid-svg-icons/faGlobe';
import { faGraduationCap as fasGraduationCap } from '@fortawesome/pro-solid-svg-icons/faGraduationCap';
import { faHandshake as fasHandshake } from '@fortawesome/pro-solid-svg-icons/faHandshake';
import { faHeart as fasHeart } from '@fortawesome/pro-solid-svg-icons/faHeart';
import { faHome as fasHome } from '@fortawesome/pro-solid-svg-icons/faHome';
import { faImages as fasImages } from '@fortawesome/pro-solid-svg-icons/faImages';
import { faKey as fasKey } from '@fortawesome/pro-solid-svg-icons/faKey';
import { faLink as fasLink } from '@fortawesome/pro-solid-svg-icons/faLink';
import { faLock as fasLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import { faLongArrowLeft as fasLongArrowLeft } from '@fortawesome/pro-solid-svg-icons/faLongArrowLeft';
import { faMap as fasMap } from '@fortawesome/pro-solid-svg-icons/faMap';
import { faMapMarker as fasMapMarker } from '@fortawesome/pro-solid-svg-icons/faMapMarker';
import { faNewspaper as fasNewspaper } from '@fortawesome/pro-solid-svg-icons/faNewspaper';
import { faPhone as fasPhone } from '@fortawesome/pro-solid-svg-icons/faPhone';
import { faPrint as fasPrint } from '@fortawesome/pro-solid-svg-icons/faPrint';
import { faSearch as fasSearch } from '@fortawesome/pro-solid-svg-icons/faSearch';
import { faSearchPlus as fasSearchPlus } from '@fortawesome/pro-solid-svg-icons/faSearchPlus';
import { faShieldAlt as fasShieldAlt } from '@fortawesome/pro-solid-svg-icons/faShieldAlt';
import { faShare as fasShare } from '@fortawesome/pro-solid-svg-icons/faShare';
import { faSignInAlt as fasSignInAlt } from '@fortawesome/pro-solid-svg-icons/faSignInAlt';
import { faSignOutAlt as fasSignOutAlt } from '@fortawesome/pro-solid-svg-icons/faSignOutAlt';
import { faStar as fasStar } from '@fortawesome/pro-solid-svg-icons/faStar';
import { faStroopwafel as fasStroopwafel } from '@fortawesome/pro-solid-svg-icons/faStroopwafel';
import { faThList as fasThList } from '@fortawesome/pro-solid-svg-icons/faThList';
import { faTimes as fasTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import { faUser as fasUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faWindowClose as fasWindowClose } from '@fortawesome/pro-solid-svg-icons/faWindowClose';

const exports = {
  fabAppStore,
  fabGooglePlay,
  fabFacebook,
  fabInstagram,
  fabLinkedin,
  fabPinterest,
  fabTumblr,
  fabTwitter,
  fabYoutube,
  fabBloggerB,
  fabXTwitter,
  farAt,
  farAward,
  farCalendar,
  farCheckCircle,
  farCircleDollar,
  farDownload,
  farEnvelope,
  farFileCertificate,
  farHandWave,
  farHandshake,
  farHeart,
  farMemoCircleCheck,
  farPrint,
  farSearch,
  farSearchPlus,
  farStroopwafel,
  farTriangleExclamation,
  farUser,
  fasAngleLeft,
  fasAngleRight,
  fasAt,
  fasAward,
  fasBars,
  fasBookReader,
  fasBug,
  fasBuilding,
  fasBullhorn,
  fasMegaphone,
  fasCalendar,
  fasCaretDown,
  fasCaretLeft,
  fasChartLine,
  fasCheck,
  fasCheckCircle,
  fasChevronLeft,
  fasCircle,
  fasCircleNotch,
  fasCity,
  fasClipboardCheck,
  fasClock,
  fasCommentDots,
  fasDollarSign,
  fasDownload,
  fasEnvelope,
  fasExclamationTriangle,
  fasFax,
  fasFileCertificate,
  fasGlobe,
  fasGraduationCap,
  fasHandshake,
  fasHeart,
  fasHome,
  fasImages,
  fasKey,
  fasLink,
  fasLock,
  fasLongArrowLeft,
  fasMap,
  fasMapMarker,
  fasNewspaper,
  fasPhone,
  fasPrint,
  fasSearch,
  fasSearchPlus,
  fasShieldAlt,
  fasShare,
  fasSignInAlt,
  fasSignOutAlt,
  fasStar,
  fasStroopwafel,
  fasThList,
  fasTimes,
  fasUser,
  fasWindowClose,
};

export default library.add(...Object.values(exports));

/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */